// MobileBrandLockup — LOCKUP da marca (símbolo S+play + "swipe tv" na
// tipografia/cor próprias da marca) pro topo das telas de auth mobile
// (login/signup/recuperação).
//
// Usa o asset PRONTO assets/brand/logo-horizontal.png (uma imagem só, já com o
// nome desenhado na fonte da marca) em vez de montar "símbolo + texto
// 'Swipe TV'" na mão com a fonte do sistema. O AppLogo (só símbolo) segue
// sendo usado na TV (WelcomeScreen), onde o nome aparece à parte; aqui
// queremos o lockup completo.
//
// Importado via Vite (hash + base relativa `base:'./'`) em vez de path
// absoluto `/brand/...`, que viraria `file:///brand/...` (404) nos wrappers
// webOS/Tizen que carregam o index via file://.
//
// Acessibilidade: a <img> carrega o nome acessível direto (alt = "Swipe TV"),
// reusando a chave i18n existente mobileAuth.brand (sem copy nova).

import { useTranslation } from '@app-iptv/i18n'

import logoHorizontal from '../assets/brand/logo-horizontal.png'

interface MobileBrandLockupProps {
  /** Altura em px do lockup (largura segue o aspect-ratio do asset). */
  height?: number | undefined
}

export function MobileBrandLockup({ height = 48 }: MobileBrandLockupProps): JSX.Element {
  const { t } = useTranslation()
  return (
    <img
      src={logoHorizontal}
      alt={t('mobileAuth.brand')}
      height={height}
      // width auto via height fixa: o asset é 1200x323 (~3.7:1); deixar a
      // largura intrínseca evita distorção. Decode async (não bloqueia 1º paint).
      style={{ height, width: 'auto', display: 'block' }}
      decoding="async"
    />
  )
}
